<template>
  <div class="LanguageSwicther">
    <ul v-if="currentLocale">
      <li
        v-for="(locale, i) in locales"
        :key="i"
        :class="{active: (locale === currentLocale)}"
        @click="setLocale(locale)"
      >
        {{ locale.toUpperCase() }}
      </li>
    </ul>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  computed: {
    ...get('localeModule', ['getLocale', 'getLocales']),

    locales() {
      return this.getLocales();
    },

    currentLocale() {
      return this.getLocale();
    },
  },

  methods: {
    async setLocale(locale) {
      await this.$store.dispatch('localeModule/changeLocale', locale);
      await this.$store.dispatch('authorsModule/fetchPaneles');
    },
  },

};
</script>

<style lang="scss" scoped>
.LanguageSwicther{
  flex: 0 0 60px !important;
  //margin-top: .3rem;
  text-align: right;
      ul {
        padding: 0;
        li {
          display: inline-block;
          padding: 0.2rem .2rem 0;
          color: white;
          font-size: 0.9rem;
          font-weight: 500;
          text-decoration: none;
          cursor: pointer;

          &:first-child {
            border-right: solid 1px white;
          }

          &.active{
            color: var(--color-primary);
          }
        }
      }
}
</style>
